/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer1_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer" | "ReplyListContainer2_viewer">;
    readonly " $refType": "ReplyListContainer1_viewer";
};
export type ReplyListContainer1_viewer$data = ReplyListContainer1_viewer;
export type ReplyListContainer1_viewer$key = {
    readonly " $data"?: ReplyListContainer1_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer1_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer2_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '1350ca9fab8b937f67b222e435ae8967';
export default node;
